module.exports = __webpack_public_path__ + "img/fh.b656598a.png";